import React, {useState, useEffect} from 'react';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON} from 'react-leaflet'
import WardBoundaries from '../../data/basemaps/BBMP_Wards_2011_region_GEO.json'
import * as turf from '@turf/turf'

function BangaloreWards() {
  const [selectedWard, setSelectedWard] = useState(null);
  const [selectedColor, setSelectedColor] = useState("#000000");

  useEffect(() => {
    // WardBoundaries.features.map(ward => {
    //   console.log(ward.properties.WARD_NO + ' - ' + ward.properties.WARD_NAME);
    //   return;
    // })
    //console.log(WardBoundaries);
  });

  let wardStyle = () => {
    return {
      fillColor: '#FF0000',
      fillOpacity: 0.2,
      color: 'black',
      weights: 1,
    };
  }

  let onWardClick = (e) => {
    return;
    e.target.setStyle({
      fillColor : selectedColor,
    });
    console.log("onWardClick - Set color from state is : " + selectedColor);
  }

  let getLatLongFromClick = (e) => {
    alert("Lat, Lon : " + e.latlng.lat + ", " + e.latlng.lng)
  }
  
  let onLeafletClick = (e) => {
    onWardClick(e);
    // getLatLongFromClick(e);
  }

  let onWardMouseOver = (e) => {
    return;
    e.target.setStyle({
      fillColor : '#0000FF',
    });
  }

  let changeColor = (e) => {
    console.log("Color from state is : " + selectedColor);
    console.log("Changing the color to : " + e.target.value);
    setSelectedColor(e.target.value); 
  }


  let onEachWard = (ward,layer) => {
    // console.log(JSON.stringify(w.properties));
    // console.log(l);
    console.log(ward);
    const areaOfWard = turf.area(ward).toFixed(2);
    console.log('Area of the ward is : ' +  areaOfWard)
    layer.bindPopup(ward.properties.WARD_NO + ' - ' + ward.properties.WARD_NAME + '-' + areaOfWard);
    layer.on({
      click : onLeafletClick,
      mouseover : onWardMouseOver,
    });
  }

  return (
    <>
    <MapContainer center={[12.9784, 77.5813]} zoomSnap={0.25} zoom={11.75} scrollWheelZoom={true}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <GeoJSON style = {wardStyle()} data={WardBoundaries.features} onEachFeature={(f,l) => onEachWard(f,l)}/>
      {/* <Marker position={[12.9052, 77.5629]}>
        <Popup>
          A pretty CSS3 popup. <br /> Easily customizable.
        </Popup>
      </Marker> */}
    </MapContainer>
    {/* <input type = "color" value = {selectedColor} onChange = {changeColor} /> */}
    </>
  );
}

export default BangaloreWards;